import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";
import {
  ContactDictionary,
  ContactDictionaryControllerApi,
} from "../../../services";

/**
 * @author Rajkumar Rathod
 */
export const useContactDictionaryCreate = () =>
  useMutationWithLoading(
    async (params: {
      contactDictionary: ContactDictionary;
      xTENANTID?: string;
    }) =>
      new ContactDictionaryControllerApi(
        getConfigObject()
      ).createContactDictionary(params.contactDictionary, params.xTENANTID)
  );
